// @flow
import queryString from 'query-string';
import { SEARCH_RADIUSES, getDefaultSearchRadius } from 'utils/constants';
import type { Action } from '../actions/searchRadius';

const queryParams =
  typeof window === 'object' ? queryString.parse(window.location.search) : {};

const parseRadius = ({ radius, sort }: { radius?: ?string, sort?: string }) => {
  if (
    radius &&
    SEARCH_RADIUSES[USER_LOCALE].find(option => option.id === radius)
  ) {
    return radius;
  }
  return getDefaultSearchRadius(sort);
};

export type State = {
  value: string,
  userHasChanged: boolean // has the user ever changed the radius manually?
};

export default function searchRadius(
  state: State = {
    value: parseRadius(queryParams),
    userHasChanged: false
  },
  action: Action
) {
  switch (action.type) {
    case 'SEARCH_RADIUS_SET': {
      return {
        ...state,
        value: action.radius,
        // userHasChanged if the user changed this value
        // in the past or in the current action
        userHasChanged: state.userHasChanged || action.didUserChange
      };
    }
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
